<template>
  <component :is="layout" />
</template>

<script>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import DefaultLayout from '@/layouts/DefaultLayout';
import PublicLayout from '@/layouts/PublicLayout';

const layouts = {
  default: DefaultLayout,
  public: PublicLayout,
};

export default {
  components: layouts,
  setup() {
    const store = useStore();
    const route = useRoute();

    const layout = computed(() => {
      const layoutName = route.meta?.layout || 'default';
      return layouts[layoutName] || layouts.default;
    });

    onMounted(() => {
      store.dispatch('initializeAuth');
    });

    return {
      layout,
    };
  },
};
</script>
